export class LegacyAgency {
  id: number
  agency: string
}

export class LegacyGeographicArea {
  id: number
  geographicAreaName: string
}

export class LegacyJurisdictionalUnit {
  unitId: number
  name: string
}

export class LegacyProtectingUnit {
  unitId: number
  name: string
}

export const jurisdiction_list = {
  "1": "BIA/Tribal",
  "2": "BLM",
  "3": "BIA/Tribal, BLM",
  "4": "USFWS",
  "5": "BIA/Tribal, USFWS",
  "6": "BLM, USFWS",
  "7": "BIA/Tribal, BLM, USFWS",
  "8": "NPS",
  "9": "BIA/Tribal, NPS",
  "10": "BLM, NPS",
  "11": "BIA/Tribal, BLM, NPS",
  "12": "USFWS, NPS",
  "13": "BIA/Tribal, USFWS, NPS",
  "14": "BLM, USFWS, NPS",
  "16": "USFS",
  "17": "BIA/Tribal, USFS",
  "18": "BLM, USFS",
  "19": "BIA/Tribal, BLM, USFS",
  "20": "USFWS, USFS",
  "21": "BIA/Tribal, USFWS, USFS",
  "22": "BLM, USFWS, USFS",
  "23": "BIA/Tribal, BLM, USFWS, USFS",
  "24": "NPS, USFS",
  "25": "BIA/Tribal, NPS, USFS",
  "26": "BLM, NPS, USFS",
  "27": "BIA/Tribal, BLM, NPS, USFS",
  "30": "BLM, USFWS, NPS, USFS",
  "31": "BIA/Tribal, BLM, USFWS, NPS, USFS",
  "32": "Other",
  "33": "BIA/Tribal, Other",
  "34": "BLM, Other",
  "35": "BIA/Tribal, BLM, Other",
  "36": "USFWS, Other",
  "37": "BIA/Tribal, USFWS, Other",
  "38": "BLM, USFWS, Other",
  "39": "BIA/Tribal, BLM, USFWS, Other",
  "40": "NPS, Other",
  "41": "BIA/Tribal, NPS, Other",
  "42": "BLM, NPS, Other",
  "43": "BIA/Tribal, BLM, NPS, Other",
  "44": "USFWS, NPS, Other",
  "48": "USFS, Other",
  "49": "BIA/Tribal, USFS, Other",
  "50": "BLM, USFS, Other",
  "51": "BIA/Tribal, BLM, USFS, Other",
  "52": "USFWS, USFS, Other",
  "54": "BLM, USFWS, USFS, Other",
  "55": "BIA/Tribal, BLM, USFWS, USFS, Other",
  "56": "NPS, USFS, Other",
  "58": "BLM, NPS, USFS, Other",
  "61": "BIA/Tribal, USFWS, NPS, USFS, Other",
  "63": "BIA/Tribal, BLM, USFWS, NPS, USFS, Other",
  "64": "ANCSA",
  "65": "BIA/Tribal, ANCSA",
  "66": "BLM, ANCSA",
  "67": "BIA/Tribal, BLM, ANCSA",
  "68": "USFWS, ANCSA",
  "69": "BIA/Tribal, USFWS, ANCSA",
  "70": "BLM, USFWS, ANCSA",
  "71": "BIA/Tribal, BLM, USFWS, ANCSA",
  "72": "NPS, ANCSA",
  "73": "BIA/Tribal, NPS, ANCSA",
  "74": "BLM, NPS, ANCSA",
  "75": "BIA/Tribal, BLM, NPS, ANCSA",
  "77": "BIA/Tribal, USFWS, NPS, ANCSA",
  "80": "USFS, ANCSA",
  "86": "BLM, USFWS, USFS, ANCSA",
  "96": "Other, ANCSA",
  "97": "BIA/Tribal, Other, ANCSA",
  "98": "BLM, Other, ANCSA",
  "101": "BIA/Tribal, USFWS, Other, ANCSA",
  "103": "BIA/Tribal, BLM, USFWS, Other, ANCSA",
  "112": "USFS, Other, ANCSA",
  "128": "State",
  "129": "BIA/Tribal, State",
  "130": "BLM, State",
  "131": "BIA/Tribal, BLM, State",
  "132": "USFWS, State",
  "133": "BIA/Tribal, USFWS, State",
  "134": "BLM, USFWS, State",
  "135": "BIA/Tribal, BLM, USFWS, State",
  "136": "NPS, State",
  "137": "BIA/Tribal, NPS, State",
  "138": "BLM, NPS, State",
  "139": "BIA/Tribal, BLM, NPS, State",
  "144": "USFS, State",
  "145": "BIA/Tribal, USFS, State",
  "146": "BLM, USFS, State",
  "147": "BIA/Tribal, BLM, USFS, State",
  "148": "USFWS, USFS, State",
  "150": "BLM, USFWS, USFS, State",
  "151": "BIA/Tribal, BLM, USFWS, USFS, State",
  "152": "NPS, USFS, State",
  "153": "BIA/Tribal, NPS, USFS, State",
  "154": "BLM, NPS, USFS, State",
  "155": "BIA/Tribal, BLM, NPS, USFS, State",
  "157": "BIA/Tribal, USFWS, NPS, USFS, State",
  "158": "BLM, USFWS, NPS, USFS, State",
  "159": "BIA/Tribal, BLM, USFWS, NPS, USFS, State",
  "160": "Other, State",
  "161": "BIA/Tribal, Other, State",
  "162": "BLM, Other, State",
  "163": "BIA/Tribal, BLM, Other, State",
  "164": "USFWS, Other, State",
  "166": "BLM, USFWS, Other, State",
  "168": "NPS, Other, State",
  "169": "BIA/Tribal, NPS, Other, State",
  "170": "BLM, NPS, Other, State",
  "171": "BIA/Tribal, BLM, NPS, Other, State",
  "175": "BIA/Tribal, BLM, USFWS, NPS, Other, State",
  "176": "USFS, Other, State",
  "178": "BLM, USFS, Other, State",
  "179": "BIA/Tribal, BLM, USFS, Other, State",
  "180": "USFWS, USFS, Other, State",
  "182": "BLM, USFWS, USFS, Other, State",
  "184": "NPS, USFS, Other, State",
  "186": "BLM, NPS, USFS, Other, State",
  "187": "BIA/Tribal, BLM, NPS, USFS, Other, State",
  "192": "ANCSA, State",
  "193": "BIA/Tribal, ANCSA, State",
  "194": "BLM, ANCSA, State",
  "195": "BIA/Tribal, BLM, ANCSA, State",
  "196": "USFWS, ANCSA, State",
  "197": "BIA/Tribal, USFWS, ANCSA, State",
  "198": "BLM, USFWS, ANCSA, State",
  "199": "BIA/Tribal, BLM, USFWS, ANCSA, State",
  "200": "NPS, ANCSA, State",
  "201": "BIA/Tribal, NPS, ANCSA, State",
  "202": "BLM, NPS, ANCSA, State",
  "203": "BIA/Tribal, BLM, NPS, ANCSA, State",
  "205": "BIA/Tribal, USFWS, NPS, ANCSA, State",
  "207": "BIA/Tribal, BLM, USFWS, NPS, ANCSA, State",
  "217": "BIA/Tribal, NPS, USFS, ANCSA, State",
  "221": "BIA/Tribal, USFWS, NPS, USFS, ANCSA, State",
  "225": "BIA/Tribal, Other, ANCSA, State",
  "227": "BIA/Tribal, BLM, Other, ANCSA, State",
  "228": "USFWS, Other, ANCSA, State",
  "231": "BIA/Tribal, BLM, USFWS, Other, ANCSA, State",
  "233": "BIA/Tribal, NPS, Other, ANCSA, State",
  "235": "BIA/Tribal, BLM, NPS, Other, ANCSA, State",
  "242": "BLM, USFS, Other, ANCSA, State",
  "256": "C&L",
  "257": "BIA/Tribal, C&L",
  "258": "BLM, C&L",
  "259": "BIA/Tribal, BLM, C&L",
  "260": "USFWS, C&L",
  "262": "BLM, USFWS, C&L",
  "264": "NPS, C&L",
  "266": "BLM, NPS, C&L",
  "268": "USFWS, NPS, C&L",
  "272": "USFS, C&L",
  "273": "BIA/Tribal, USFS, C&L",
  "274": "BLM, USFS, C&L",
  "276": "USFWS, USFS, C&L",
  "277": "BIA/Tribal, USFWS, USFS, C&L",
  "286": "BLM, USFWS, NPS, USFS, C&L",
  "288": "Other, C&L",
  "289": "BIA/Tribal, Other, C&L",
  "290": "BLM, Other, C&L",
  "291": "BIA/Tribal, BLM, Other, C&L",
  "292": "USFWS, Other, C&L",
  "294": "BLM, USFWS, Other, C&L",
  "304": "USFS, Other, C&L",
  "305": "BIA/Tribal, USFS, Other, C&L",
  "306": "BLM, USFS, Other, C&L",
  "307": "BIA/Tribal, BLM, USFS, Other, C&L",
  "308": "USFWS, USFS, Other, C&L",
  "384": "State, C&L",
  "385": "BIA/Tribal, State, C&L",
  "386": "BLM, State, C&L",
  "387": "BIA/Tribal, BLM, State, C&L",
  "388": "USFWS, State, C&L",
  "389": "BIA/Tribal, USFWS, State, C&L",
  "390": "BLM, USFWS, State, C&L",
  "392": "NPS, State, C&L",
  "394": "BLM, NPS, State, C&L",
  "400": "USFS, State, C&L",
  "401": "BIA/Tribal, USFS, State, C&L",
  "402": "BLM, USFS, State, C&L",
  "403": "BIA/Tribal, BLM, USFS, State, C&L",
  "404": "USFWS, USFS, State, C&L",
  "406": "BLM, USFWS, USFS, State, C&L",
  "407": "BIA/Tribal, BLM, USFWS, USFS, State, C&L",
  "408": "NPS, USFS, State, C&L",
  "410": "BLM, NPS, USFS, State, C&L",
  "411": "BIA/Tribal, BLM, NPS, USFS, State, C&L",
  "412": "USFWS, NPS, USFS, State, C&L",
  "414": "BLM, USFWS, NPS, USFS, State, C&L",
  "415": "BIA/Tribal, BLM, USFWS, NPS, USFS, State, C&L",
  "416": "Other, State, C&L",
  "417": "BIA/Tribal, Other, State, C&L",
  "418": "BLM, Other, State, C&L",
  "419": "BIA/Tribal, BLM, Other, State, C&L",
  "420": "USFWS, Other, State, C&L",
  "422": "BLM, USFWS, Other, State, C&L",
  "424": "NPS, Other, State, C&L",
  "426": "BLM, NPS, Other, State, C&L",
  "432": "USFS, Other, State, C&L",
  "433": "BIA/Tribal, USFS, Other, State, C&L",
  "434": "BLM, USFS, Other, State, C&L",
  "435": "BIA/Tribal, BLM, USFS, Other, State, C&L",
  "442": "BLM, NPS, USFS, Other, State, C&L",
  "443": "BIA/Tribal, BLM, NPS, USFS, Other, State, C&L",
  "447": "BIA/Tribal, BLM, USFWS, NPS, USFS, Other, State, C&L",
  "451": "BIA/Tribal, BLM, ANCSA, State, C&L",
  "483": "BIA/Tribal, BLM, Other, ANCSA, State, C&L",
  "512": "BOR",
  "528": "USFS, BOR",
  "534": "BLM, USFWS, USFS, BOR",
  "642": "BLM, State, BOR",
  "656": "USFS, State, BOR",
  "658": "BLM, USFS, State, BOR",
  "659": "BIA/Tribal, BLM, USFS, State, BOR",
  "674": "BLM, Other, State, BOR",
  "675": "BIA/Tribal, BLM, Other, State, BOR",
  "682": "BLM, NPS, Other, State, BOR",
  "722": "BLM, USFS, ANCSA, State, BOR",
  "915": "BIA/Tribal, BLM, USFS, State, C&L, BOR"
}